(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccineDetailController', VaccineDetailController);

    VaccineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Vaccine'];

    function VaccineDetailController($scope, $rootScope, $stateParams, previousState, entity, Vaccine) {
        var vm = this;

        vm.vaccine = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:vaccineUpdate', function(event, result) {
            vm.vaccine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
